export default __webpack_public_path__ + "static/media/home-events-conference-img-13.6dd3f87e.jpg";